<template>
  <div class="on-print app-layout-shell">
    <v-dialog v-model="loginDialog" width="400">
      <LoginDialog />
    </v-dialog>

    <div v-if="!globalStatus" class="on-print app-layout-content">
      <toolbar />
      <navbar />
      <v-main class="app-main">
        <CancelDialog :show="showCancel" @gotoAccount="gotoAccount" />
        <router-view></router-view>
      </v-main>
      <v-footer app class="app-footer" height="44">
        <a class="footer-support" href="tel:+19175297186" aria-label="Call Taleem support at 917 529 7186">
          <span class="footer-support__icon"><v-icon color="primary" size="16">mdi-headset</v-icon></span>
          <span class="footer-support__copy"><small>Need help?</small><strong>(917) 529-7186</strong></span>
        </a>
        <v-spacer />
        <div class="footer-product">
          <span>Powered by</span>
          <a href="https://taleem.app" target="_blank" rel="noopener">taleem.app</a>
          <span class="footer-divider">•</span>
          <span>&copy; {{ new Date().getFullYear() }}</span>
          <span class="footer-version">v{{ version }}</span>
        </div>
      </v-footer>
    </div>
    <div v-else>
      <v-dialog v-model="globalStatus" hide-overlay persistent width="300">
        <v-card color="primary" class="pa-3" dark>
          <v-card-text>
            {{ $t("labels.pleaseStandBy") }}
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
    <v-dialog v-model="loadingStatus.status" persistent width="300">
      <v-card color="purple darken-3" dark>
        <v-card-text>
          {{ loadingStatus.title }}
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import RegisterStoreModule from "@/mixins/RegisterStoreModule";
import layoutStore from "./store";
import Navbar from "@/modules/Layout/components/NavigationPanel.vue";
import LoginDialog from "../Authentication/components/LoginDialog";
import Toolbar from "@/modules/Layout/components/Toolbar.vue";
import accountService from "@/modules/Account/service.js";
import backofficeService from "../../api/backoffice.js";
import CancelDialog from "@/modules/Layout/components/cancelDialog.vue";
import { mapGetters, mapActions } from "vuex";
const pjson = require("../../../package.json");

export default {
  name: "layout",
  mixins: [RegisterStoreModule],
  data() {
    return {
      subscriptionStatus: "active",
      showCancel: false,
      include: ["home", "customer-home"],
      authenticated: true,
      polling: null,
      Subscription: null,
    };
  },
  async created() {
    try {
      this.registerStoreModule("layout", layoutStore);
      await this.initUser();
      await this.initType();
      this.setGlobalStatus(false);
      this.pollData();
      // if (this.currentBusiness.subscribable) this.checkSubcription();
      // console.log('this.currentUser', this.currentUser)
      if (this.currentUser.userType === 'teacher') {
        this.$router.push({ name: "thome" });
      }
      this.$store.dispatch('layout/initDrawer', this.$vuetify.breakpoint.xsOnly)
    } catch (error) {
      this.$router.push("/logout");
    }
  },
  components: {
    Navbar,
    CancelDialog,
    Toolbar,
    LoginDialog,
  },
  // sockets: {
  //   connect: function() {
  //     // console.log('socket connected')
  //     this.joinSocket();
  //   },
  //   message: function(data) {
  //     // console.log('message', data)
  //   }
  // },
  computed: {
    ...mapGetters("global", [
      "currentUser",
      "currentBusiness",
      "globalStatus",
      "loadingStatus",
      "loginDialog",
    ]),
    version() {
      return pjson.version;
    },
  },
  props: {
    source: String,
  },
  // beforeDestroy() {
  //   clearInterval(this.polling);
  // },

  watch: {
    subscriptionStatus(val) {
      if (val === "canceled") {
        this.showCancel = true;
      }
    },
    authenticated(val) {
      if (!val) {
        this.$swal(
          "Session Expired",
          "Your token was expaired please login again.",
          "warning"
        ).then(() => {
          // this.$router.push("/login");
          this.setLoginDialog(true);
        });
      }
    },
  },
  methods: {
    ...mapActions("global", [
      "setGlobalStatus",
      "setLoginDialog",
      "initUser",
      "initType",
    ]),
    // checkSubcription() {
    //   this.getSubscription();
    // },
    gotoAccount() {
      this.showCancel = false;
      this.$router.push("/account");
    },
    getSubscription() {
      return accountService
        .getSubscription({
          subscription_id: this.currentBusiness.subscription_id,
        })
        .then((result) => {
          console.log("asdfksdfsdf", result);
          this.Subscription = result.data;
          if (this.Subscription.status === "canceled")
            this.subscriptionStatus = "canceled";
        });
    },
    // sendSocket(data) {
    //   // console.log('sendSocket', data)
    //   this.$socket.emit("userStatus", data);
    // },
    // joinSocket() {
    //   if (this.currentUser) {
    //     this.$socket.emit("join", this.currentUser);
    //   }
    // },
    async checkToken() {
      this.authenticated = await backofficeService.valid();
    },
    pollData() {
      this.polling = setInterval(() => {
        if (
          !localStorage.getItem(`${process.env.VUE_APP_STORAGE_PREFIX}token`)
        ) {
          this.authenticated = false;
        }
      }, 1000);
    },
  },
};
</script>

<style scoped>
.app-layout-shell,
.app-layout-content {
  min-height: 100vh;
  background: #f6f8f6;
}

.app-main {
  min-height: calc(100vh - 44px);
  background: #f6f8f6;
}

.app-main ::v-deep .v-main__wrap {
  min-height: 100%;
  background: #f6f8f6;
}

.app-footer {
  padding: 0 18px !important;
  border-top: 1px solid #e2e8e2 !important;
  background: rgba(251, 252, 251, .98) !important;
  color: #748078;
}

.footer-support {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: inherit;
  text-decoration: none;
}

.footer-support__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 8px;
  background: #eaf5eb;
}

.footer-support__copy {
  display: flex;
  align-items: baseline;
  gap: 6px;
}

.footer-support small {
  color: #879188;
  font-size: 9px;
}

.footer-support strong {
  color: #344239;
  font-size: 11px;
}

.footer-support:hover strong,
.footer-product a:hover {
  color: #2e7d32;
}

.footer-product {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 9px;
}

.footer-product a {
  color: #2e7d32;
  font-weight: 750;
  text-decoration: none;
}

.footer-divider {
  color: #bdc6be;
}

.footer-version {
  margin-left: 3px;
  padding: 2px 6px;
  border-radius: 5px;
  color: #667269;
  background: #eef2ee;
  font-weight: 650;
}

@media (max-width: 599px) {
  .app-footer {
    height: 40px !important;
    padding: 0 10px !important;
  }

  .footer-support__icon,
  .footer-support small,
  .footer-product > span:not(.footer-version) {
    display: none;
  }

  .footer-support__copy {
    gap: 0;
  }
}
</style>
